<template>
  <div>
    <v-dialog v-model="dialog.attachment"
      @keydown.esc="dialog.attachment = false"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card v-if="Object.keys(selected.attachment).length > 0"
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title 
          class="d-flex align-center py-0 px-3 text-right popup-header">
          Lampiran {{ selected.attachment.type === 'image' ? 'Gambar' : 'PDF' }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#2391d0">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.attachment = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <v-img v-if="selected.attachment.type === 'image'"
            width="100%"
            height="auto"
            alt="locafe" 
            :src="selected.attachment.url"
            class="ma-auto border-radius">
            <template v-slot:placeholder>
              <v-row
                class="fill-height"
                align="center"
                justify="center">
                <v-progress-circular 
                  indeterminate 
                  color="#2391d0">
                </v-progress-circular>
              </v-row>
            </template>
          </v-img>

          <div v-if="selected.attachment.type === 'document'">
            <iframe 
              :src="`${selected.attachment.url}#toolbar=0`" 
              allowfullscreen
              frameborder="0" 
              width="100%"
              height="1000"
              style="border-radius: 15px; border: 2px solid #323639;">
            </iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card 
      color="white"
      class="box-shadow border-radius">
      <v-card-text>
        <div
          class="title font-weight-bold black--text mb-1">
          Lampiran
        </div>

        <div
          class="d-flex align-center mb-4">
          <div>
            Berikut data dokumen / lampiran ajuan izin usaha.
          </div>

          <v-spacer />
        </div>

        <div>
          <v-card 
            v-for="(item, index) in detail.ajuan_lampiran"
            :key="index"
            flat
            color="transparent"
            class="mb-6">
            <div
              class="pb-2">
              <span
                class="line-text-second"
                style="opacity: 70%;"
                v-html="item.name">
              </span>
            </div>

            <v-divider 
              style="border-top: 5px solid #f3f3f3; border-radius: 50px;" />
            
            <div v-if="item.file.length > 0"
              class="mt-4">
              <v-row>
                <v-col 
                  v-for="(item_img, index_img) in item.file"
                  :key="index_img"
                  cols="6" 
                  md="4">
                  <v-card 
                    @click="selected.attachment = item_img; dialog.attachment = true;"
                    flat
                    width="100%"
                    height="200"
                    class="d-flex align-center justify-center"
                    style="border-radius: 15px;
                          border: 2px solid #eaeaea; 
                          border-style: dashed;
                          box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                    <v-img v-if="item_img.type === 'image'"
                      alt="kominfo" 
                      width="100%"
                      height="200"
                      :src="item_img.url"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="#2391d0">
                          </v-progress-circular>
                        </v-row>
                      </template>

                      <div 
                        class="font-weight-bold color-default"
                        style="position: absolute; top: 5px; left: 5px;">
                        Gambar
                      </div>
                    </v-img>

                    <div v-if="item_img.type === 'document'"
                      class="d-flex align-center justify-center">
                      <iframe 
                        :src="`${item_img.url}#toolbar=0`" 
                        allowfullscreen
                        frameborder="0" 
                        width="100%"
                        height="200"
                        style="border-radius: 15px; border: 2px solid #323639;">
                      </iframe>

                      <div
                        style="width: 100%; height: 200px; position: absolute; background: transparent;">
                      </div>

                      <div 
                        class="font-weight-bold color-default"
                        style="position: absolute; top: 5px; left: 5px;">
                        PDF
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <div v-else
              class="mt-4 orange--text font-italic">
              Lampiran belum tersedia
            </div>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          fullscreen: false,
          attachment: false
        },
        sheet: {
          form: false
        },
        selected: {
          attachment: {}
        },
        upload: {
          folder: null
        },
        index_file: '',
        form: {
          id: '',
          nama_badan_usaha: '',
          nib_no: '',
          nib_alamat: '',
          kbli: '',
          lokasi_usaha: '',
          luas: '',
          keterangan: '',
          lampiran: [],
          koordinat: [],
          extra: {}
        },
        process: {
          load: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      
    }
  }
</script>